import React from "react";
import { ApiMedia } from "src/api/types";
import Tag, { TagProps } from "src/components/Tag";
import FileUploadItemIcon from "src/components/form/file-upload/FileUploadItemIcon";

interface FileUploadItemProps extends TagProps {
	media: ApiMedia;
	isFullname: boolean;
}

const FileUploadItem = ({
	media,
	isFullname,
	...rest
}: FileUploadItemProps) => {
	const className = `${rest.className || ""}`;
	return (
		<Tag {...{ ...rest, className }}>
			<div className="flex items-center gap-2 flex-1">
				<FileUploadItemIcon {...{ media }} />
				{isFullname ? media.filename : media.short_filename}
			</div>
			{rest?.children}
		</Tag>
	);
};

FileUploadItem.defaultProps = {
	theme: "gray",
	size: "default",
	isFullname: false,
};

export default FileUploadItem;
